import { infoStore } from '../../../store/infoStore';
import { useDateHook } from '../../../hook/useDateHook';
import { End } from './End';
import { ProgressTicket } from './ProgressTicket';

export const ProgressInfo = ({
  goMainEventTab,
  goOnlineTab,
  goOfflineTab,
}: {
  goMainEventTab: () => void;
  goOnlineTab: () => void;
  goOfflineTab: () => void;
}) => {
  const { isSatelliteEnd } = useDateHook();
  const { info } = infoStore();
  const earlyEnd = isSatelliteEnd() && info.ticketCnt > 0;

  if (isSatelliteEnd() || info.ticketCnt === 0) {
    return <End goOfflineTab={goOfflineTab} isEarlyEnd={earlyEnd} />;
  }

  return <ProgressTicket goMainEventTab={goMainEventTab} goOnlineTab={goOnlineTab} />;
};
